var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:[("alert-" + _vm.type)]},[_c('FontAwesomeIcon',{staticClass:"help-icon fa",class:{large: _vm.large},attrs:{"icon":_vm.autoIcon}}),_c('div',{staticClass:"text"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }